// Woo Checkout – login modal open/close
let __wkLoginMounted = false;

export function mount(root = document) {
  if (__wkLoginMounted) return;
  __wkLoginMounted = true;

  const qs  = (s, r = document) => r.querySelector(s);
  const qsa = (s, r = document) => Array.from(r.querySelectorAll(s));
  const on  = (el, evt, fn) => el && el.addEventListener(evt, fn);

  function mountLoginModal(r = document) {
    qsa('[data-wk-open]', r).forEach(btn => {
      on(btn, 'click', e => {
        e.preventDefault();
        const t = qs(btn.getAttribute('data-wk-open'));
        if (t) t.hidden = false;
      });
    });
    qsa('[data-wk-close]', r).forEach(btn => {
      on(btn, 'click', e => {
        e.preventDefault();
        const dlg = btn.closest('.wk-modal');
        if (dlg) dlg.hidden = true;
      });
    });
    on(document, 'keydown', e => {
      if (e.key === 'Escape') qsa('.wk-modal').forEach(m => (m.hidden = true));
    });
    on(document, 'click', e => {
      const dialog = e.target.closest?.('.wk-modal__dialog');
      const isOverlay = e.target.classList?.contains('wk-modal');
      if (!dialog && isOverlay) e.target.hidden = true;
    });
  }

  mountLoginModal(root);

  // rebind bij Woo updates als de DOM wijzigt
  ['updated_checkout', 'wc_fragment_refresh'].forEach(evt =>
    document.body.addEventListener(evt, () => mountLoginModal(document))
  );
}
